{
    "filter_header__title": "Filtres utilisés",
    "filter_header__title_short": "Filtres",
    "filter_header__filter_button": "Filtrer",
    "filter_header__delete_button": "Supprimer",
    "filter_header__delete_all_button": "Tout supprimer"
}
